var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15 20.725C5.45 20.725 4.75208 20.5583 4.05625 20.225C3.36042 19.8916 2.8 19.4416 2.375 18.875C2.79167 18.85 3.2125 18.6708 3.6375 18.3375C4.0625 18.0041 4.275 17.525 4.275 16.9C4.275 16.1083 4.55208 15.4312 5.10625 14.8687C5.66042 14.3062 6.33333 14.025 7.125 14.025C7.91667 14.025 8.58958 14.3062 9.14375 14.8687C9.69792 15.4312 9.975 16.1083 9.975 16.9C9.975 17.9666 9.60417 18.8708 8.8625 19.6125C8.12083 20.3541 7.21667 20.725 6.15 20.725ZM6.14835 18.85C6.69112 18.85 7.15208 18.6604 7.53125 18.2812C7.91042 17.9021 8.1 17.4402 8.1 16.8957C8.1 16.6152 8.00833 16.3791 7.825 16.1875C7.64167 15.9958 7.40833 15.9 7.125 15.9C6.84167 15.9 6.60833 15.9958 6.425 16.1875C6.24167 16.3791 6.15 16.6166 6.15 16.9C6.15 17.2833 6.10208 17.6312 6.00625 17.9437C5.91042 18.2562 5.76667 18.543 5.575 18.8039C5.65833 18.8346 5.75417 18.85 5.8625 18.85H6.14835ZM11.725 14.9L9.1 12.3L18.55 2.84998L21.125 5.49998L11.725 14.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrush);
export default __webpack_public_path__ + "static/media/icon-brush.92afe16d7775ade90119fac21ea91747.svg";
export { ForwardRef as ReactComponent };